module.exports = __webpack_public_path__ + "img/pic_zb_d3.b16ffdd6.png";